import { ReferenceLink } from '../../../models/ReferenceLink';

export class Details {
  constructor(
    private readonly consequences: string | null,
    private readonly explanation: string | null,
    private readonly expertise: string | null,
    private readonly access: string | null,
    private readonly resources: string | null,
    private readonly references: ReferenceLink[]
  ) {}

  getConsequences() {
    return this.consequences ?? '';
  }

  getExplanation() {
    return this.explanation ?? '';
  }

  getExpertise() {
    return this.expertise ?? '';
  }

  getAccess() {
    return this.access ?? '';
  }

  getResources() {
    return this.resources ?? '';
  }

  getReferences() {
    return this.references;
  }
}
